/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpClientService } from '@sa/core/services/http-client.service';
import { API_ENDPOINTS } from '@sa/shared/constants/api-endpoints';
import { Observable, Subject } from 'rxjs';
import { AgentMetaData } from '@sa/shared/interfaces/AgentMetaData';
@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private httpClientService = inject(HttpClientService);
  private refreshSubject = new Subject<void>();
  refresh$ = this.refreshSubject.asObservable();

  triggerRefresh() {
    this.refreshSubject.next();
  }
  
  proceedToInvokeAgent(agentMetaData: AgentMetaData, tenantGuid: string): Observable<any> {
    return this.httpClientService.post<any>(
      API_ENDPOINTS.PROCEED_TO_INVOKE_AGENT(tenantGuid),
     agentMetaData
    );
  }

  proceedToInvokeOrchestratorAgent(agentMetaData: AgentMetaData, tenantGuid: string): Observable<any> {
    return this.httpClientService.post<any>(
      API_ENDPOINTS.PROCEED_TO_INVOKE_ORCHESTRATOR_AGENT(tenantGuid),
     agentMetaData
    );
  }
 
}
